import { Action } from '@ngrx/store';

export enum ShopIdAction {
  Set = '[ShopId] Set',
  Reset = '[ShopId] Reset',
  Sync = '[ShopId] Sync',
}

export class Set implements Action {
  readonly type = ShopIdAction.Set;

  constructor(public payload: number) {}
}

export class Reset implements Action {
  readonly type = ShopIdAction.Reset;
}

export class Sync implements Action {
  readonly type = ShopIdAction.Sync;

  constructor(public payload: number[]) {}
}

export type ShopIdActionType = Set | Reset | Sync;
